/* All Tracking Status service 
 *
 * Angular Module: trackerbase-app.services.all-tracking-statuses-service
 * Injected Service: AllTrackingStatuses
 */
import angular from "angular";

import TrackingStatus from "../models/TrackingStatus";

const AllStatuses = [
    //new TrackingStatus(id, statusName, isApproved, isReported)
    new TrackingStatus(1, "Proposed", false, false),
    new TrackingStatus(2, "Scheduled", true, false),
    new TrackingStatus(3, "Tracked - Access Denied", false, true),
    new TrackingStatus(4, "Tracked - Reported", false, true),
    new TrackingStatus(5, "Cancelled", false, false),
    new TrackingStatus(6, "Not Tracked", false, true),
    new TrackingStatus(7, "Rejected", false, false)
];

class AllTrackingStatusesService {
    constructor() {
        this._StatusMap = new Map();

        AllStatuses.forEach((ts) => {
            this._StatusMap.set(
                ts.trackingStatusName,
                AllStatuses[ts.trackingStatusId - 1]
            );
        });

        this._AllStatuses = AllStatuses;
    }

    toString() {
        return "AllTrackingStatusesService";
    }

    getFromId(tsId) {
        return TrackingStatus.Copy(this._AllStatuses[(tsId - 1)]);
    }

    getFromName(tsName) {
        return TrackingStatus.Copy(this._StatusMap.get(tsName));
    }

    get AvailableStatuses() {
        return this._AllStatuses;
    }

    getProposedStatus() {
        return TrackingStatus.Copy(this._StatusMap.get("Proposed"));
    }

    getReportedStatuses() {
        let reportedStatuses =
            this._AllStatuses
                .filter((status) => {
                    return (status.isReported);
                })
                .map((status) => {
                    return TrackingStatus.Copy(status);
                });

        return reportedStatuses;
    }

    getApprovedStatuses() {
        let approvedStatuses =
            this._AllStatuses
                .filter((status) => {
                    return (status.isApproved);
                })
                .map((status) => {
                    return TrackingStatus.Copy(status);
                });

        return approvedStatuses;
    }
}

AllTrackingStatusesService.$inject = [];

export default angular
    .module("trackerbase-app.services.all-tracking-statuses-service", [
    ])
    .service("AllTrackingStatuses", AllTrackingStatusesService)
    .name;




//////////////////
// WEBPACK FOOTER
// ./src/services/AllTrackingStatusesService.js
// module id = G9+l
// module chunks = 1